import { render, staticRenderFns } from "./UpdateNotifyTeacher.vue?vue&type=template&id=6686c390&scoped=true"
import script from "./UpdateNotifyTeacher.vue?vue&type=script&lang=js"
export * from "./UpdateNotifyTeacher.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotifyTeacher.vue?vue&type=style&index=0&id=6686c390&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6686c390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6686c390')) {
      api.createRecord('6686c390', component.options)
    } else {
      api.reload('6686c390', component.options)
    }
    module.hot.accept("./UpdateNotifyTeacher.vue?vue&type=template&id=6686c390&scoped=true", function () {
      api.rerender('6686c390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifyTeacher/UpdateNotifyTeacher.vue"
export default component.exports